import { render, staticRenderFns } from "./VehicleDistribution.vue?vue&type=template&id=3ed2f1c2&scoped=true&"
import script from "./VehicleDistribution.vue?vue&type=script&lang=js&"
export * from "./VehicleDistribution.vue?vue&type=script&lang=js&"
import style0 from "./VehicleDistribution.vue?vue&type=style&index=0&id=3ed2f1c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2f1c2",
  null
  
)

export default component.exports